document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('[data-add-a-jack]').forEach(function(root){

      if (!root || root.dataset.aajInit) return;
      root.dataset.aajInit = 'true';

      var overlay = root.querySelector('[data-add-a-jack-overlay]');
      var drawer = root.querySelector('[data-add-a-jack-drawer]');
      var openBtn = root.querySelector('[data-add-a-jack-open]');
      var closeBtn = root.querySelector('[data-add-a-jack-close]');
      var singleBtn = root.querySelector('[data-add-a-jack-single-add]');
      var lastFocused = null;

      function openDrawer() {
        if (!drawer || !overlay) return;
        lastFocused = document.activeElement;
        overlay.hidden = false;
        drawer.hidden = false;
        requestAnimationFrame(function () {
          overlay.setAttribute('data-visible', 'true');
          drawer.setAttribute('data-visible', 'true');

          // Body Class Add
          document.body.classList.add('add-a-jack-drawer-open');
        });
        document.documentElement.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
        document.addEventListener('keydown', onKeydown);
      }

      function closeDrawer() {
        if (!drawer || !overlay) return;
        overlay.removeAttribute('data-visible');
        drawer.removeAttribute('data-visible');
        // Body Class Remove
        document.body.classList.remove('add-a-jack-drawer-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKeydown);
        setTimeout(function () {
          overlay.hidden = true;
          drawer.hidden = true;
        }, 300);
        if (lastFocused) lastFocused.focus();
      }

      function onKeydown(e) {
        if (e.key === 'Escape') closeDrawer();
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      // ---------------- ADD TO CART (shared) ----------------
      function addVariantToCart(variantId, btn) {
        if (!variantId || !btn || btn.dataset.loading === 'true') return;
        btn.dataset.loading = 'true';

        var loadingSpinner = btn.querySelector('[data-loading-spinner]');
        if (loadingSpinner) loadingSpinner.hidden = false;

        fetch(
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
          }
        )
          .then(function (res) {
            if (!res.ok)
              return res.json().then(function (err) {
                throw err;
              });
            return res.json();
          })
          .then(function () {
            return refreshCartState().then(function () {
              // spinner off, "Added" on
              btn.dataset.loading = 'false';
              if (loadingSpinner) loadingSpinner.hidden = true;

              var label = btn.querySelector('[data-label]');
              var addedLabel = btn.querySelector('[data-added-label]');
              btn.setAttribute('data-added', 'true');
              if (label) label.hidden = true;
              if (addedLabel) addedLabel.hidden = false;

              setTimeout(function () {
                var label2 = btn.querySelector('[data-label]');
                var addedLabel2 = btn.querySelector('[data-added-label]');
                btn.removeAttribute('data-added');

                if (label2) label2.hidden = false;
                if (addedLabel2) addedLabel2.hidden = true;
              }, 9000);
            });
          })
          .catch(function (err) {
            console.error('Add a Jack: could not add to cart', err);
          })
          .finally(function () {
            btn.dataset.loading = 'false';
            if (loadingSpinner) loadingSpinner.hidden = true;
          });
      }

      if (singleBtn) {
        singleBtn.addEventListener('click', function () {
          addVariantToCart(singleBtn.dataset.variantId, singleBtn);
        });
      }

      root.querySelectorAll('[data-add-a-jack-row-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addVariantToCart(btn.dataset.variantId, btn);
        });
      });

      function refreshCartState() {
        // cart-drawer classes
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer?.classList.remove('is-empty');
        // hide empty drawer content
        document.querySelectorAll('.drawer_inner-empty').forEach((el) => {
          el.style.display = 'none';
        });

        // load #CartDrawer into cart-drawer
        return fetch(location.href)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            const newCart = doc.querySelector('#CartDrawer');
            const currentCart = document.querySelector('#CartDrawer');
            if (newCart && currentCart) {
              currentCart.innerHTML = newCart.innerHTML;
            }

            const newBubble = doc.querySelector('#cart-icon-bubble');
            const currentBubble = document.querySelector('#cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          });
      }

    });

});